import { Link } from 'react-router-dom';

const ResidentialCTA = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <h2 className="text-4xl font-bold text-navy mb-6">
          Ready to Upgrade Your Home?
        </h2>
        <p className="text-charcoal text-lg leading-relaxed mb-10">
          Contact NS Electrical WA today for professional residential electrical services. We provide safe, compliant solutions with quality workmanship guaranteed.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-4">
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 bg-gold text-navy px-8 py-4 rounded-lg font-bold text-sm tracking-wider hover:bg-gold/90 transition-all whitespace-nowrap cursor-pointer"
          >
            REQUEST A QUOTE
          </Link>
          <a
            href="tel:0412345678"
            className="inline-flex items-center gap-2 border-2 border-navy text-navy px-8 py-4 rounded-lg font-bold text-sm tracking-wider hover:bg-navy hover:text-white transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line text-xl w-5 h-5 flex items-center justify-center"></i>
            CALL NOW
          </a>
        </div>
      </div>
    </section>
  );
};

export default ResidentialCTA;